import { useTranslation } from "react-i18next";


export function PrintCard() {
    const { t } = useTranslation();

    return <h3>{t('searchCard.menu.print')}</h3>
}